import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

export const inputVariants = cva(
  [
    "flex w-full min-w-0 rounded-control border border-line bg-surface px-3.5 text-base text-ink shadow-[0_1px_2px_rgba(17,30,24,0.03)]",
    "transition-[border-color,box-shadow] hover:border-accent-line placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50",
    "aria-invalid:border-danger-line",
  ],
  {
    variants: { size: { md: "h-11", lg: "h-12" } },
    defaultVariants: { size: "md" },
  },
);

export interface InputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "size">, VariantProps<typeof inputVariants> {}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, size, type = "text", ...props },
  ref,
) {
  return (
    <input ref={ref} type={type} className={cn(inputVariants({ size }), className)} {...props} />
  );
});
